import { render, staticRenderFns } from "./JointSetting.vue?vue&type=template&id=6778803d&"
import script from "./JointSetting.vue?vue&type=script&lang=js&"
export * from "./JointSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports